module.exports = __webpack_public_path__ + "static/media/bnr3.f12705fe.jpg";